import adminHttpCommon from "../helper/adminHttpCommon";

export const adminLogin = (credentials) => {
  return adminHttpCommon.post("admin-dashboard/login/", credentials, {
    skipAuth: true,
  });
};

export const getAdminDashboard = () => {
  return adminHttpCommon.get("admin-dashboard/");
};
